import {
    Box,
    Button,
    Dialog,
    Theme,
    Typography,
    useTheme
} from "@mui/material";
import { useHistory, useRouteMatch } from "react-router";
import { useDispatch } from "react-redux";
import {
    resendOtp,
    validateOtp
} from "../../redux-store/actions/cart";
import {
    OtpResponseMessage,
    ResendOtpResponseBody,
    ValidateOtpResponseBody
} from "../../redux-store/types/cart";
import { useState } from "react";
import { showError } from "../../redux-store/actions/auth";
import { SuccessIcon } from "../../assets/SvgIcons";
import OTPForm from "../../lib/formik/OtpForm";

interface RouterStateData {
    token: string;
    cartId: string;
    otpResponseMessages: OtpResponseMessage[];
    // id: number | string;
    // otpMessage: string;
}

export default function VerifyCartOtp(): JSX.Element {
    const { params, url } = useRouteMatch();
    const dispatch = useDispatch()
    const history = useHistory();
    const theme = useTheme();
    const routerStateObj = history.location.state as RouterStateData;
    // const [routerStateObj, setRouterStateObj] = useState<RouterStateData>(history.location.state as RouterStateData)
    const [paymentNotRequired, setPaymentNotRequired] = useState<boolean>(false);
    const [paymentFalseMessage, setPaymentFalseMessage] = useState<string>('');

    const handleSubmit = async (otp: string, id: number) => {
        const payload = {
            otp,
            token: routerStateObj?.token ?? "",
            id: `${id}`,
            cartId: routerStateObj?.cartId ?? ""
        }

        const response = await (dispatch(validateOtp(payload)) as unknown as Promise<ValidateOtpResponseBody>)

        if (response?.isSuccess) {
            if (response?.cartId) {
                if (response?.paymentRequired) {
                    history.replace('/cart/payment', {
                        cartId: response?.cartId ?? "",
                        token: response?.token ?? ""
                    })
                }
                else {
                    setPaymentFalseMessage(response?.message ?? "");
                    setPaymentNotRequired(true);
                }
            } else {
                const otpResponse = routerStateObj?.otpResponseMessages?.map(item =>
                    item.id === response?.id ? { id: response.id, isVerified: true, message: response?.message } : item
                );
                history.replace({
                    pathname: url,
                    state: { cartId: routerStateObj?.cartId, otpResponseMessages: otpResponse, token: routerStateObj?.token }  //updating id in location:state if resend otp is success
                });
            }

        }
        if (!response?.isSuccess) {
            dispatch(showError(response?.message ?? ""))
        }
    }

    const handleResend = async (id: number) => {
        const payload = {
            cartId: routerStateObj?.cartId ?? "",
            id: `${id}`,
            token: routerStateObj?.token ?? ""
        }

        const response = await (dispatch(resendOtp(payload)) as unknown as Promise<ResendOtpResponseBody>)

        if (response?.isSuccess) {
            const otpResponse = routerStateObj?.otpResponseMessages?.map(item =>
                item.id === response?.requestForId ? { ...item, id: response.id, maximum_attempts: response?.maximum_attemps, failed_attempts: response?.failed_attempts, message: response?.message, numberOfOTPTries: response?.numberOfOTPTries } : item
            );
            history.replace({
                pathname: url,
                state: { cartId: routerStateObj?.cartId, otpResponseMessages: otpResponse, token: routerStateObj?.token }  //updating id in location:state if resend otp is success
            });
            // setRouterStateObj({
            //     token: response?.token ?? "",
            //     cartId: response?.cartId ?? "",
            //     otpResponseMessages: otpResponse,
            //     // id: "4",
            //     // otpMessage: response?.message ?? ""
            // })
        }
    }

    const handlePaymentFalsePopup = () => {
        setPaymentNotRequired(false);
        history.replace('/investor-dashboard');
    }

    return (
        <>
            <Box>
                <Typography
                    variant="h1"
                    sx={(theme: Theme) => ({
                        lineHeight: "32.5px",
                        color: theme.palette.text.primary
                    })}
                >
                    Transaction Confirmation
                </Typography>
                <Box
                    sx={(theme: Theme) => ({
                        marginTop: "25px",
                        borderRadius: "20px",
                        backgroundColor: theme.palette.common.white,
                        padding: "50px",
                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: 'column',
                        gap: 2,
                    })}
                >
                    {/* <Box sx={{ width: "50%" }}>
                        <OTPForm
                            onSubmit={(otp) => handleSubmit(otp, 5)}
                            onResend={() => handleResend(5)}
                            otpMessage={routerStateObj?.otpMessage ?? ""}
                            warningMessage=""
                        />
                    </Box> */}
                    {routerStateObj?.otpResponseMessages?.map((item, idx) => {
                        return (
                            <Box key={idx} sx={{ width: "50%", border: `1px solid ${theme.palette.text.secondary}`, p: 3, borderRadius: '20px' }}>
                                {item.isVerified
                                    ? <Typography>{item.message}</Typography>
                                    : <OTPForm
                                        onSubmit={(otp) => handleSubmit(otp, item.id)}
                                        onResend={() => handleResend(item.id)}
                                        otpMessage={item.message ?? ''}
                                        numberOfTries={item?.numberOfOTPTries ?? 0}
                                        warningMessage=""
                                    />
                                }
                            </Box>)
                    })}
                </Box>
            </Box>
            <Dialog
                onClose={() => setPaymentNotRequired(false)}
                open={paymentNotRequired}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "48px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingTop: "15px",
                            rowGap: "12px"
                        }}
                    >
                        <SuccessIcon />
                        <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({
                                lineHeight: "25px",
                                letterSpacing: "0.01px",
                                color: theme.palette.text.primary
                            })}
                        >
                            Success!
                        </Typography>
                        <Typography
                            variant="subtitle_400"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.secondary,
                                textAlign: "center"
                            })}
                        >
                            {paymentFalseMessage}
                        </Typography>
                    </Box>
                    <Box>
                        <Button
                            variant="contained"
                            fullWidth
                            sx={(theme: Theme) => ({
                                borderRadius: "4px",
                                padding: "13px 20px",
                                backgroundColor: theme.palette.primary[500],
                                ...theme.typography.body_600,
                                fontSize: "16px",
                                lineHeight: "20px"
                            })}
                            onClick={handlePaymentFalsePopup}
                        >
                            Go To Dashboard
                        </Button>
                    </Box>
                </Box>

            </Dialog>
        </>
    )
}